module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy_wrap"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "register_info"
  }, [_c('ul', _vm._l((_vm.datas), function(info) {
    return _c('li', [_c('fold', {
      attrs: {
        "title": info.title,
        "partOne": info.article.partOne,
        "partTwo": info.article.partTwo,
        "partTh": info.article.partTh
      }
    })], 1)
  }))]), _vm._v(" "), _c('div')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p_top"
  }, [_c('h1', [_vm._v("Privacy Policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p_title"
  }, [_c('h2', [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_vm._v("Welcome to 51Talk American Academy, a web-based service that teaches English to young learners. We respect your privacy and want you to know what information we collect and what we do with that information. This Privacy Policy applies to all information we collect or receive from you. ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e57bdb4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/other/privacy_policy.vue
// module id = 857
// module chunks = 1